module.exports = __webpack_public_path__ + "./fonts/fade-stagger-circles.4d5f77a96698fa82699b190d460b7e38.svg";